var map = {
	"./af/Competency.json": 64377,
	"./af/Dimension.json": 97533,
	"./af/Interview.json": 46250,
	"./af/InterviewQuestion.json": 78267,
	"./af/Keyword.json": 82401,
	"./af/Question.json": 93434,
	"./af/SubCompetency.json": 20530,
	"./af/Tip.json": 22544,
	"./af/auth.json": 58542,
	"./af/common.json": 8557,
	"./af/login.json": 57155,
	"./af/menu.json": 17867,
	"./af/register.json": 29463,
	"./af/welcome.json": 47064,
	"./en/App.json": 23138,
	"./en/Competency.json": 81565,
	"./en/Dimension.json": 74533,
	"./en/Interview.json": 84034,
	"./en/InterviewQuestion.json": 25651,
	"./en/Keyword.json": 61600,
	"./en/Question.json": 29293,
	"./en/Sophia.json": 37390,
	"./en/SubCompetency.json": 82385,
	"./en/Tip.json": 75981,
	"./en/auth.json": 31974,
	"./en/common.json": 83147,
	"./en/login.json": 9459,
	"./en/menu.json": 81507,
	"./en/register.json": 68669,
	"./en/welcome.json": 33067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8973;